import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatResponseTime',
  standalone: false,
})
export class FormatResponseTimePipe implements PipeTransform {
  transform(value: number): string {
    if (value >= 1000) {
      return (value / 1000).toFixed(2) + ' s';
    }
    return value.toFixed(0) + ' ms';
  }
}
